import { singletonFactory } from '@warehouse/shared/util';
import { MediaInfoTrackMappingRepository } from "../core/mediaInfoTrackMapping.repository";
import mediaInfoTracks from '../../../src/assets/json-administration-profiles/mediaInfoTrackMapping.json';
import { MediaInfoTrackMapping } from '../core';

export class MediaInfoTrackMappingRepositoryJson implements MediaInfoTrackMappingRepository {
    getMediaInfoTrackMappingConfig(): Record<string, MediaInfoTrackMapping[]> {
        return mediaInfoTracks;
    };
};

export const mediaInfoTrackMappingRepositorySingleton = singletonFactory<MediaInfoTrackMappingRepository>({
    factory: () => new MediaInfoTrackMappingRepositoryJson(),
});